/**
 * Member-facing display labels for the two library collections.
 * Machinery values ('faq' / 'sop') are never changed; this is display-only.
 */
export function docTypeLabel(collection: string | null | undefined): string {
  return collection === "faq" ? "FAQ" : "Step by Step";
}

/**
 * Strip a leading "Start here:" / "Start Here: " prefix for display only.
 * Stored titles are unchanged. Case-insensitive, tolerant of extra spaces.
 */
const START_HERE_RE = /^\s*start\s*here\s*[:\-\u2013\u2014]\s*/i;

export function stripStartHerePrefix(title: string | null | undefined): string {
  if (!title) return "";
  return title.replace(START_HERE_RE, "").trim() || title;
}
